module.exports = __webpack_public_path__ + "static/media/esilde3.556c1133.jpg";